import { CellContext, ColumnDef } from "@tanstack/react-table";
import { useEffect, useState } from "react";
import { useStyles } from "./style";

export const SBEditableColumn = (props: SBEditableColumnProps) => {
	const {
		getValue,
		row: { index },
		column: { id },
		table,
	} = props;

	const classes = useStyles();
	const initialValue = getValue();

	const [value, setValue] = useState<any>(initialValue);
	const onBlur = () => {
		(table.options.meta as any)?.updateData(props.row.id, id, value);
	};

	useEffect(() => setValue(initialValue), [initialValue]);

	return (
		<input
			value={value as string}
			onChange={(e) => setValue(e.target.value)}
			onBlur={onBlur}
			className={classes.editableColumn}
		/>
	);
};

interface SBEditableColumnProps extends CellContext<any, unknown> {}
